import { NgWizardConfig, THEME } from 'ng-wizard3';

export const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default,
};
